import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';
import { SearchInfoRegular } from '@fluentui/react-icons';
import { t } from 'i18next';

const useClasses = makeStyles({
    askButton: {
        textAlign: 'left',
        margin: '2px 0',
        padding: '6px 10px',
        userSelect: 'none',
        cursor: 'pointer',
        backgroundColor: tokens.colorNeutralBackground1,
        color: tokens.colorNeutralForeground1,
        borderRadius: tokens.borderRadiusXLarge,
        border: `1px solid ${tokens.colorNeutralStroke1}`,
        '&selectors': {
            '&:empty': {
                visibility: 'hidden',
            },
            '@media(max-width: 899px)': {},
        },
        ':hover': {
            backgroundColor: tokens.colorNeutralBackground4,
            borderTopColor: tokens.colorNeutralForeground3,
            borderRightColor: tokens.colorNeutralForeground3,
            borderBottomColor: tokens.colorNeutralForeground3,
            borderLeftColor: tokens.colorNeutralForeground3,
            color: tokens.colorNeutralForeground1,
        },
        width: 'fit-content',
        maxWidth: '100%',
    },
    askButtonContainer: {
        display: 'flex',
        alignItems: 'flex-end',
        width: '100%',
        flexDirection: 'column',
        flexWrap: 'wrap',
        '&selectors': {
            '@media(max-width: 899px)': {
                flexDirection: 'column',
            },
        },
    },
    askButtonContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        paddingLeft: tokens.spacingHorizontalL,
        width: '100%',
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'flex-end',
        gap: tokens.spacingHorizontalXS,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
    },
    searchIcon: {
        fontSize: tokens.fontSizeBase500,
    },
});

interface Props {
    items?: string[];
    onClick: (text: string) => void;
}

export const ChatSupplementaryQuestions: React.FC<Props> = ({ items, onClick }) => {
    const classes = useClasses();
    if (items === undefined || items.length === 0) {
        return null;
    }
    return (
        <div className={classes.askButtonContent}>
            <div className={classes.header}>
                <SearchInfoRegular className={classes.searchIcon} />
                {t('chatSupplementaryQuestions.suggestions')}
            </div>
            <div className={`${classes.askButtonContainer} `}>
                {items.map((text, index) => (
                    <div
                        key={index}
                        className={classes.askButton}
                        onClick={() => {
                            onClick(text);
                        }}
                    >
                        {text}
                    </div>
                ))}
            </div>
        </div>
    );
};
